// src/hooks/usePageTracking.jsx
import { useEffect, useRef } from "react";
import { record } from "aws-amplify/analytics";

export const usePageTracking = (pageName) => {
  // Store the session start time in a ref so it persists between renders.
  const sessionStartTimeRef = useRef(Date.now());

  useEffect(() => {
    // Record the page view event.
    record({
      name: "page_view",
      attributes: { page: pageName },
    });

    // Record the session start event.
    sessionStartTimeRef.current = Date.now();
    record({
      name: "session_start",
      attributes: { page: pageName },
    });

    // Define a function to record session end.
    const recordSessionEnd = () => {
      const sessionEndTime = Date.now();
      const durationInSeconds = Math.round(
        (sessionEndTime - sessionStartTimeRef.current) / 1000
      );
      record({
        name: "session_end",
        attributes: {
          page: pageName,
          duration: durationInSeconds.toString(),
        },
        metrics: { sessionDuration: durationInSeconds },
      });
    };

    // Listen for browser unload to catch abrupt page exits.
    window.addEventListener("beforeunload", recordSessionEnd);

    // Cleanup: remove the event listener and record the session end.
    return () => {
      window.removeEventListener("beforeunload", recordSessionEnd);
      recordSessionEnd();
    };
  }, [pageName]);
};